module.exports = __webpack_public_path__ + "static/img/index_right_top_logo.4f9a567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_right_top_logo.jpg
// module id = xk04
// module chunks = 0